import React from 'react';
import Shimmer from './Shimmer';

const ContactShimmer = () => (
    <div className="relative">
        <div className="absolute inset-0 bg-[#228B22]/5 skew-y-3 h-[80%] mt-20"></div>

        <section className="relative py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
                    {/* Contact Info - Left Side */}
                    <div className="lg:col-span-2 space-y-8">
                        {/* Coordonnées */}
                        <div className="bg-white/70 backdrop-blur-xl p-8 rounded-3xl shadow-xl">
                            <Shimmer className="h-8 w-48 mb-8 rounded"/>

                            <div className="space-y-6">
                                {[1, 2, 3].map((item) => (
                                    <div key={item} className="flex items-start p-4 rounded-2xl">
                                        <Shimmer className="w-12 h-12 rounded-2xl"/>
                                        <div className="ml-4">
                                            <Shimmer className="h-4 w-24 rounded mb-2"/>
                                            <Shimmer className="h-5 w-48 rounded"/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Map */}
                        <div className="bg-white/70 backdrop-blur-xl rounded-3xl shadow-xl overflow-hidden">
                            <Shimmer className="w-full h-64"/>
                        </div>
                    </div>

                    {/* Contact Form - Right Side */}
                    <div className="lg:col-span-3">
                        <div className="bg-white/70 backdrop-blur-xl p-8 lg:p-12 rounded-3xl shadow-xl">
                            {/* Form Header */}
                            <div className="flex items-center gap-4 mb-8">
                                <Shimmer className="w-14 h-14 rounded-2xl"/>
                                <div>
                                    <Shimmer className="h-8 w-64 rounded mb-2"/>
                                    <Shimmer className="h-5 w-80 rounded"/>
                                </div>
                            </div>

                            {/* Form Fields */}
                            <div className="space-y-8">
                                {/* Name and Email fields */}
                                {[1, 2].map((field) => (
                                    <div key={field} className="relative">
                                        <Shimmer className="h-4 w-24 rounded absolute -top-2 left-4"/>
                                        <Shimmer className="w-full h-14 rounded-xl"/>
                                    </div>
                                ))}

                                {/* Message field */}
                                <div className="relative">
                                    <Shimmer className="h-4 w-24 rounded absolute -top-2 left-4"/>
                                    <Shimmer className="w-full h-40 rounded-xl"/>
                                </div>

                                {/* Submit button */}
                                <Shimmer className="w-full h-14 rounded-xl"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
);

export default ContactShimmer;